export default __webpack_public_path__ + "static/automobile-click-to-map-1af5493d1f745c1e5fe964b79034b240.gif";